import {
  Box,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../api/APIs";
import { LoadingButton } from "@mui/lab";
import BottomFullWidthButtonContainer from "../../components/shared/BottomFullWidthButtonContainer";
import ReferralBg from "../../assets/images/refferal-bg.svg";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

function ReferralPage() {
  const navigate = useNavigate();
  const { loading, apiCall: postReferralCode } = useRequest(
    BalootUserV2APIs.postReferralCode
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const handleSubmit = () => {
    postReferralCode({
      data: { referralCode: referralCode.toUpperCase() },
      onSuccess: () => {
        navigate("/app", { replace: true });
      },
      onError: (error) => {
        setErrorMessage(error.message);
      },
    });
  };

  const navigateHome = () => {
    navigate("/app", { replace: true });
  };

  const isFormValid = () => {
    if (referralCode.length > 5) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <PageContentContainer
        sx={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Box
          mt={1}
          sx={{
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            overflow: "auto",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img src={ReferralBg} width={156} height={145} />
        </Box>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2" color="grey.2">
            کد معرف
          </Typography>
        </Box>
        <TextField
          value={referralCode}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {referralCode.length > 0 && (
                    <IconButton
                      onClick={() => {
                        setErrorMessage("");
                        setReferralCode("");
                      }}
                    >
                      <CancelOutlinedIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                  )}
                </Box>
              </InputAdornment>
            ),
          }}
          inputProps={{
            maxLength: 6,
            style: { textTransform: "uppercase" },
          }}
          onChange={(event) => {
            setErrorMessage("");
            if (event.target.value === null) {
              setReferralCode("");
            } else {
              setReferralCode(event.target.value);
            }
          }}
          sx={{
            mt: "8px",
            "& .MuiOutlinedInput-root fieldset ,& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline ":
              {
                borderColor: errorMessage ? "red.main" : "black",
              },
          }}
          fullWidth
        />
        <Typography mt={1} variant="subtitle1" color="red.main">
          {errorMessage}
        </Typography>
        <BottomFullWidthButtonContainer sx={{ boxShadow: "none" }}>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <LoadingButton
              loading={loading}
              onClick={handleSubmit}
              disabled={!isFormValid()}
              sx={{
                color: "common.white",
                typography: "h3",
                width: "100%",
              }}
              variant="contained"
              fullWidth
            >
              ثبت
            </LoadingButton>
            <Typography
              variant="h5"
              color="primary.main"
              fontSize={18}
              mt={3}
              onClick={navigateHome}
            >
              کد معرف ندارم
            </Typography>
          </Box>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default ReferralPage;
